<template>
    <div class="layout-px-spacing">
        <teleport to="#breadcrumb">
            <ul class="navbar-nav flex-row">
                <li>
                    <div class="page-header">
                        <nav class="breadcrumb-one" aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="javascript:;">User</a></li>
                                <li class="breadcrumb-item active" aria-current="page"><span>Permissions</span>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </li>
            </ul>
        </teleport>

        <!-- Create Permission Modal -->
        <div class="modal fade" id="createPermissionModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Create New Permission</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="handleCreatePermission">
                            <div class="mb-3">
                                <label for="permissionName" class="form-label">Permission Name</label>
                                <input type="text" class="form-control" id="permissionName" v-model="newPermission.name"
                                    required>
                            </div>
                            <div class="mb-3">
                                <label for="permissionDescription" class="form-label">Description</label>
                                <textarea class="form-control" id="permissionDescription"
                                    v-model="newPermission.description" rows="3"></textarea>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                                <button type="submit" class="btn btn-info" :disabled="isSubmitting">
                                    <span v-if="isSubmitting" class="spinner-grow text-white me-2 align-self-center"
                                        role="status" aria-hidden="true"></span>
                                    {{ isSubmitting ? 'Creating...' : 'Create Permission' }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- Edit Permission Modal -->
        <div class="modal fade" id="editPermissionModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Edit Permission</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="handleUpdatePermission">
                            <div class="mb-3">
                                <label for="editPermissionName" class="form-label">Permission Name</label>
                                <input type="text" class="form-control" id="editPermissionName"
                                    v-model="editingPermission.name" required>
                            </div>
                            <div class="mb-3">
                                <label for="editPermissionDescription" class="form-label">Description</label>
                                <textarea class="form-control" id="editPermissionDescription"
                                    v-model="editingPermission.description" rows="3"></textarea>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                                <button type="submit" class="btn btn-info" :disabled="isSubmitting">
                                    <span v-if="isSubmitting" class="spinner-grow text-white me-2 align-self-center"
                                        role="status" aria-hidden="true"></span>
                                    {{ isSubmitting ? 'Updating...' : 'Update Permission' }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="row layout-top-spacing">
            <div class="col-xl-12 col-lg-12 col-md-12 col-12 layout-spacing">
                <div class="panel br-4">
                    <div class="panel-body">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h3 class="mb-0">Here are your available Permissions so far! <br>
                                <strong>You have {{ permissionsList.length }} registered Permissions.</strong>
                            </h3>
                            <button class="btn btn-primary d-flex align-items-center" data-bs-toggle="modal"
                                data-bs-target="#createPermissionModal">
                                Create Permission
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-plus ms-2">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </button>
                        </div>

                        <div class="table-responsive">
                            <div v-if="isLoading" class="text-center py-4">
                                <div class="spinner-border text-primary" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>

                            <template v-else>
                                <table class="table table-hover table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Description</th>
                                            <th>Created By</th>
                                            <th>Date Created</th>
                                            <th class="text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="permission in permissionsList" :key="permission.id">
                                            <td>{{ permission.name }}</td>
                                            <td class="text-center">{{ permission.description }}</td>
                                            <td>{{ permission.user ? permission.user.username : 'N/A' }}</td>
                                            <td>{{ formatDate(permission.created_at) }}</td>
                                            <td class="text-center">
                                                <button @click="prepareEdit(permission)"
                                                    class="btn btn-primary btn-sm me-2 mt-1" data-bs-toggle="modal"
                                                    data-bs-target="#editPermissionModal">
                                                    Edit
                                                </button>
                                                <button @click="deletePermission(permission.id)"
                                                    class="btn btn-danger btn-sm mt-1">
                                                    <i class="feather icon-trash-2"></i> Delete
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-if="permissionsList.length === 0" class="text-center py-4">
                                    <p>No permissions found</p>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.layout-px-spacing {
    min-height: calc(100vh - 170px) !important;
}

.cursor-pointer {
    cursor: pointer;
}

.modal-content {
    border-radius: 0.75rem;
}

.modal-header {
    border-bottom: 1px solid #e9ecef;
    padding: 1.5rem;
}

.modal-title {
    font-weight: 600;
}

.modal-body {
    padding: 1.5rem;
}

.modal-footer {
    border-top: 1px solid #e9ecef;
    padding: 1.5rem;
}
</style>

<script setup>
import { ref, onMounted } from "vue";
import { useMeta } from "@/composables/use-meta";
import axios from 'axios';
import { BASE_URL } from '@/Config/config';
import Swal from 'sweetalert2';
import { useStore } from 'vuex';
import { Modal } from 'bootstrap';

useMeta({ title: "View Permissions" });

const store = useStore();
const permissionsList = ref([]);
const isLoading = ref(false);
const isSubmitting = ref(false);

// Create permission state
const newPermission = ref({
    name: '',
    description: ''
});

// Edit permission state
const editingPermission = ref({
    id: null,
    name: '',
    description: ''
});

let createModal = null;
let editModal = null;

const showSuccessAlert = (message) => {
    Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: message,
        padding: '2em',
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false
    });
};

const showErrorAlert = (message) => {
    Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: message,
        padding: '2em',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK'
    });
};

const showConfirmationAlert = (message) => {
    return Swal.fire({
        title: 'Are you sure?',
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
    });
};

onMounted(async () => {
    // Initialize Bootstrap modals
    createModal = new Modal(document.getElementById('createPermissionModal'));
    editModal = new Modal(document.getElementById('editPermissionModal'));

    await fetchPermissions();
});

const fetchPermissions = async () => {
    try {
        isLoading.value = true;
        const response = await axios.get(`${BASE_URL}/users/permissions/index`, {
            headers: {
                'Authorization': `Bearer ${store.state.token}`,
                'X-Company-ID': store.state.currentCompany?.id
            }
        });
        permissionsList.value = response.data.permissions || [];
        console.log('Permissions fetched successfully:', permissionsList.value);
    } catch (error) {
        console.error('Error fetching permissions:', error);
        showErrorAlert(error.response?.data?.message || 'Failed to load permissions');
    } finally {
        isLoading.value = false;
    }
};

const handleCreatePermission = async () => {
    try {
        isSubmitting.value = true;
        const response = await axios.post(`${BASE_URL}/users/permissions/store`, newPermission.value, {
            headers: {
                'Authorization': `Bearer ${store.state.token}`,
                'X-Company-ID': store.state.currentCompany?.id
            }
        });

        permissionsList.value.unshift(response.data.permission);
        showSuccessAlert('Permission created successfully!');
        createModal.hide();
        resetNewPermissionForm();
        await fetchPermissions();
    } catch (error) {
        console.error('Error creating permission:', error);
        showErrorAlert(error.response?.data?.message || 'Failed to create permission');
    } finally {
        isSubmitting.value = false;
    }
};

const prepareEdit = (permission) => {
    editingPermission.value = {
        id: permission.id,
        name: permission.name,
        description: permission.description
    };
};

const handleUpdatePermission = async () => {
    try {
        isSubmitting.value = true;
        const response = await axios.put(
            `${BASE_URL}/users/permissions/update/${editingPermission.value.id}`,
            editingPermission.value,
            {
                headers: {
                    'Authorization': `Bearer ${store.state.token}`,
                    'X-Company-ID': store.state.currentCompany?.id
                }
            }
        );

        const index = permissionsList.value.findIndex(p => p.id === editingPermission.value.id);
        if (index !== -1) {
            permissionsList.value[index] = response.data.permission;
        }

        showSuccessAlert('Permission updated successfully!');
        editModal.hide();
        await fetchPermissions();
    } catch (error) {
        console.error('Error updating permission:', error);
        showErrorAlert(error.response?.data?.message || 'Failed to update permission');
    } finally {
        isSubmitting.value = false;
    }
};

const deletePermission = async (id) => {
    const result = await showConfirmationAlert('This action cannot be undone. Are you sure you want to delete this permission?');

    if (result.isConfirmed) {
        try {
            await axios.delete(`${BASE_URL}/users/permissions/delete/${id}`, {
                headers: {
                    'Authorization': `Bearer ${store.state.token}`,
                    'X-Company-ID': store.state.currentCompany?.id
                }
            });
            permissionsList.value = permissionsList.value.filter(v => v.id !== id);
            showSuccessAlert('Permission deleted successfully!');
            await fetchPermissions();
        } catch (error) {
            console.error('Error deleting permission:', error);
            showErrorAlert(error.response?.data?.message || 'Failed to delete permission');
        }
    }
};

const resetNewPermissionForm = () => {
    newPermission.value = {
        name: '',
        description: ''
    };
};

const formatDate = (dateString) => {
    if (!dateString) return '—';
    const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    };
    return new Date(dateString).toLocaleString(undefined, options);
};
</script>